import { render, staticRenderFns } from "./EnvironmentsSwitch.vue?vue&type=template&id=f85a376e&"
import script from "./EnvironmentsSwitch.vue?vue&type=script&lang=js&"
export * from "./EnvironmentsSwitch.vue?vue&type=script&lang=js&"
import style0 from "./EnvironmentsSwitch.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports